import React, { useState } from "react";
import "./SavenDaysChalange.css";
import Navbar from "../../Shared/Navbar";

const SevenDaysChalange = () => {
    const milestones = [
        {
            day: "Day 1",
            title: "Introduction",
            description: "Get familiar with the challenge and its rules.",
            details: "Understand the structure of the challenge, the scoring system, and the tools required for participation."
        },
        {
            day: "Day 2",
            title: "Basics",
            description: "Learn the basics of competitive programming.",
            details: "Topics include input/output handling, basic algorithms, and problem-solving techniques."
        },
        {
            day: "Day 3",
            title: "Intermediate",
            description: "Solve intermediate-level problems.",
            details: "Focus on data structures like arrays, stacks, and queues, and solve problems using these concepts."
        },
        {
            day: "Day 4",
            title: "Advanced",
            description: "Tackle advanced-level problems.",
            details: "Work on graph algorithms, dynamic programming, and advanced problem-solving strategies."
        },
        {
            day: "Day 5",
            title: "Optimization",
            description: "Learn optimization techniques for coding.",
            details: "Explore time complexity, space optimization, and efficient coding practices."
        },
        {
            day: "Day 6",
            title: "Mock Contest",
            description: "Participate in a mock contest to test your skills.",
            details: "Simulate a real contest environment, solve problems under time constraints, and analyze your performance."
        },
        {
            day: "Day 7",
            title: "Final Review",
            description: "Review your progress and prepare for real contests.",
            details: "Recap all topics, revisit weak areas, and get tips for participating in competitive coding contests."
        },
    ];

    // State to track which milestone is open; only first is open by default
    const [openIndex, setOpenIndex] = useState(0);

    // Helper to determine if a milestone is locked
    const isLocked = (index) => index !== 0;

    return (
        <>
        <Navbar/>
        <div className="seven-days-container">
            <div className="seven-days-header">Seven Days Competitive Coding Challenge</div>
            <div className="seven-days-timeline">
                {milestones.map((milestone, index) => (
                    <div className="seven-days-timeline-item" key={index}>
                        <div className="seven-days-timeline-marker">
                            <span className="seven-days-timeline-circle">{index + 1}</span>
                            {index < milestones.length - 1 && <span className="seven-days-timeline-line"></span>}
                        </div>
                        <div
                            className={`seven-days-timeline-content${isLocked(index) ? " locked" : ""}`}
                            // Only allow opening if not locked
                            onClick={() => {
                                if (!isLocked(index)) setOpenIndex(index);
                            }}
                            style={{ cursor: isLocked(index) ? "not-allowed" : "pointer" }}
                        >
                            <div className="seven-days-timeline-title">
                                {milestone.title}
                                {isLocked(index) && (
                                    <span className="seven-days-lock-icon" title="Locked" style={{ marginLeft: 8, color: "#b0b4c1" }}>
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                            <path d="M6 8V6a4 4 0 118 0v2" stroke="#b0b4c1" strokeWidth="2" strokeLinecap="round"/>
                                            <rect x="4" y="8" width="12" height="8" rx="2" stroke="#b0b4c1" strokeWidth="2"/>
                                            <circle cx="10" cy="12" r="1" fill="#b0b4c1"/>
                                        </svg>
                                    </span>
                                )}
                            </div>
                            {openIndex === index && !isLocked(index) && (
                                <>
                                    <div className="seven-days-timeline-description">{milestone.description}</div>
                                    <div className="seven-days-timeline-details">{milestone.details}</div>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </>
    );
};

export default SevenDaysChalange;
